import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    isOpen : false  
}

const checkSidebarStatus = createSlice({
    name: 'sidebarStatus',
    initialState,
    reducers: {
        toggleSidebarTrue: (state) => {
            state.isOpen = true
        },
        toggleSidebarFalse: (state) => {
            state.isOpen = false
        }
    }
})

export const { toggleSidebarTrue, toggleSidebarFalse } = checkSidebarStatus.actions
export default checkSidebarStatus.reducer